import { createContext, useContext } from 'react';
import type { Context } from 'react';

export interface IProductsContext {
  usage: 'TAGGING' | 'STYLING';
}

export const ProductsContext: Context<IProductsContext> = createContext({} as IProductsContext);

export function useProductsContext() {
  const contextData = useContext(ProductsContext);
  return contextData;
}
